import styled from 'styled-components';

export const ExportDropDownItem = styled.div`
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ExportDropdownCount = styled.div`
  color: var(--primary);
  font-weight: 600;
`;
